module.exports = __webpack_public_path__ + "img/pr-4.a3bb6554.png";